import React from 'react';
import * as Yup from 'yup';
import { Formik, Form, FormikHelpers } from 'formik';
import { Column, Columns } from '@codeparva/ui-components-library';
import { getDeviceInfo } from '../helpers/DeviceFIngerPrint';
import { FontAwesomeIcon } from '../../../utilities/iconLoader/FontAwesomeIcon';
import { ContactUsPageTypes } from '../ContactUsPageTypes';
import { baseURL, emailAddresses } from '../helpers/constants';
import axios from 'axios';
import { desktopscreensize } from '../../../utilities/constants';
import { useWindowDimensions } from '../../../utilities/Dimensions';
import { Icon } from '../../../utilities/icomoon-css';
import { IconConfig } from '../../contactUsPage/helpers/constants';
import { useVariant } from '../hooks/VariantContext';
import {
  GetMessageBox,
  GetNewContactUs,
  GetPadding,
  GetRadioButtons,
  GetSendButton,
  GetSubjectDropDown,
} from '../helpers/FormikFormHelper';

interface Values {
  name: string;
  firstName: string;
  lastName: string;
  senderEmail: string;
  receiverEmail: Array<string>;
  phoneNumber: string;
  message: any;
  messageTextArea: string;
  IsExistingTenant: string;
  subject: string;
  customTemplate: null;
}

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const SignupSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is a required field.'),
  lastName: Yup.string().required('Last Name is a required field.'),
  subject: Yup.string().required(),
  phoneNumber: Yup.string()
    .matches(phoneRegExp, 'Phone number is not valid.')
    .required('Phone Number is a required field.'),
  senderEmail: Yup.string()
    .email('Please fill in correct Email Address.')
    .required('Email Address is a required field.'),
  messageTextArea: Yup.string().required('Message is a required field.'),
});

export const FormikForm = ({
  emailAddress,
}: ContactUsPageTypes.TContactDetails) => {
  const variant = useVariant();
  const getSuccessMessga = (message: string) => {
    return (
      <Columns>
        <Column className="is-flex is-align-items-center">
          <Icon
            name="tfw-tick-circle-cp"
            color={IconConfig.successIconColor}
            size={IconConfig.successIconSize}
          />
          <p className="SuccessMessage pl-2">{message}</p>
        </Column>
      </Columns>
    );
  };

  const getErrorMessageIcon = () => {
    return (
      <FontAwesomeIcon
        iconClassName="FaExclamationCircle"
        iconContextProps={{
          className: 'ErrorMessageIcon mr-2',
        }}
      />
    );
  };
  const getErrorMessage = (message: string) => {
    return (
      <Columns>
        <Column className="is-flex is-align-items-center">
          {getErrorMessageIcon()}
          <p className="ErrorMessage">{message}</p>
        </Column>
      </Columns>
    );
  };

  const getErrors = (errors: any) => {
    return errors ? (
      <div className="ErrorMessage is-flex is-align-items-center">
        {getErrorMessageIcon()}
        {errors}
      </div>
    ) : (
      <></>
    );
  };

  const { width } = useWindowDimensions();

  return (
    <Formik
      initialValues={{
        name: '',
        firstName: '',
        lastName: '',
        senderEmail: '',
        receiverEmail: [''],
        messageTextArea: '',
        phoneNumber: '',
        message: '',
        IsExistingTenant: 'Yes',
        subject: 'I have a question about your services.',
        customTemplate: null,
      }}
      validationSchema={SignupSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(
        contents: Values,
        { setSubmitting, resetForm, setStatus }: FormikHelpers<Values>
      ) => {
        const deviceInfo = getDeviceInfo();

        contents.name = contents.firstName.concat(' ', contents.lastName);
        if (
          contents.subject === 'I ran into a technical issue on your website.'
        ) {
          contents.receiverEmail = emailAddresses;
          emailAddress &&
            emailAddress.map(email => contents.receiverEmail.push(email.data));
          contents.message =
            contents.messageTextArea +
            '<br>' +
            'Device information:' +
            ' ' +
            JSON.stringify(deviceInfo);
        } else {
          emailAddress &&
            emailAddress.map(email => contents.receiverEmail.push(email.data));
          contents.message = contents.messageTextArea;
        }
        const requestOptions = {
          contents,
        };
        axios
          .post(baseURL, requestOptions)
          .then(response => {
            if (response.status === 200) {
              setStatus({
                messageType: 'success',
                message:
                  'Thank you for approching us, We will get back to you soon.',
              });
              return response.data;
            } else {
              setStatus({
                messageType: 'failure',
                message:
                  'Something went wrong from our end, We are doing our best to fix it.',
              });
              throw new Error('Something went wrong');
            }
          })
          .then(res => console.log(res));
        setSubmitting(false);
        resetForm();
      }}
      any
    >
      {({ errors, status }) => (
        <>
          <Form className="FormikForm">
            <Columns className={GetPadding(variant)}>
              <Column className={`is-6 py-2 pb-5 FormControl is-full`}>
                <GetNewContactUs
                  label="First Name"
                  name="firstName"
                  placeholder="John"
                  type="Text"
                  variant={variant}
                />
                {getErrors(errors.firstName)}
              </Column>
              <Column
                className={`is-6 py-2 FormControl ${(variant ===
                  'newContactUsLightTheme' ||
                  width <= desktopscreensize) &&
                  'is-full'}`}
              >
                <GetNewContactUs
                  label={'Last Name'}
                  name={'lastName'}
                  placeholder={'Smith'}
                  type={'Text'}
                  variant={variant}
                />
                {getErrors(errors.lastName)}
              </Column>
            </Columns>

            <Columns className={GetPadding(variant)}>
              <Column
                className={`py-2 pb-5 FormControl ${(variant ===
                  'newContactUsLightTheme' ||
                  width <= desktopscreensize) &&
                  'is-full'}`}
              >
                <GetNewContactUs
                  label={'Email Address'}
                  name={'senderEmail'}
                  placeholder={'johnsmith@gmail.com'}
                  type={'senderEmail'}
                  variant={variant}
                />
                {getErrors(errors.senderEmail)}
              </Column>
            </Columns>

            <Columns
              className={`${GetPadding(
                variant
              )} is-multiline ContactFormRadioGroup`}
            >
              <Column
                className={`is-6 py-2 FormControl  ${(variant ===
                  'newContactUsLightTheme' ||
                  width <= desktopscreensize) &&
                  'is-full'}`}
              >
                <GetNewContactUs
                  label={'Phone Number'}
                  name={'phoneNumber'}
                  placeholder={'Phone Number'}
                  type={'phoneNumber'}
                  variant={variant}
                />
                {getErrors(errors.phoneNumber)}
              </Column>
              <Column className="is-6">
                <GetRadioButtons variant={variant} />
              </Column>
            </Columns>

            <Columns className={GetPadding(variant)}>
              <GetSubjectDropDown />
            </Columns>

            <Columns className={GetPadding(variant)}>
              <Column className="FormControl pt-2 pb-0">
                <GetMessageBox variant={variant} />
                {getErrors(errors.messageTextArea)}
              </Column>
            </Columns>
            {status &&
              ((status.messageType === 'success' &&
                getSuccessMessga(status.message)) ||
                (status.messageType === 'failure' &&
                  getErrorMessage(status.message)))}
            <Columns>
              <GetSendButton variant={variant} emailAddress={emailAddress} />
            </Columns>
          </Form>
        </>
      )}
    </Formik>
  );
};
